export const HERO_PLAN_FEATURES = [
  'Aircraft Availability',
  'FBO Parking',
  'Cross-Border Customs',
  'Multi-City Routing',
  'Group Charter Programs',
  'Final Week Demand',
];

export const SUBNAV_LINKS = [
  { id: 'why-private', label: 'Why Private Jet' },
  { id: 'host-airport-table', label: 'Host Cities' },
  { id: 'pricing', label: 'Cost Analysis' },
  { id: 'fbo-strategy', label: 'Best Airports' },
  { id: 'regulations', label: 'Cross-Border Planning' },
  { id: 'faq', label: 'FAQ & Contact' },
];

export const WHY_PRIVATE_CARDS = [
  {
    title: 'Multi-City Flexibility',
    body: 'Build a custom itinerary across any combination of World Cup 2026 host cities without airline schedules, layovers, or connection risk. Follow the tournament on your terms.',
  },
  {
    title: 'Compressed Match Windows',
    body: 'Fly private between World Cup 2026 host cities and turn 24-hour commercial ordeals into 2-hour door-to-door transfers. No gate holds. No checked baggage delays.',
  },
  {
    title: 'Cross-Border Simplicity',
    body: 'Charter a private jet for FIFA 2026 and your operator handles customs, overflight permits, and immigration coordination in advance across all three host nations.',
  },
  {
    title: 'Stadium-Adjacent Access',
    body: 'Secondary business-aviation airports put you minutes from World Cup venues. The right FBO gets you closer to kickoff than any commercial terminal will.',
  },
];

export const HOST_AIRPORT_ROWS = [
  {
    rowOrder: 1,
    hostCity: 'New York / New Jersey',
    country: 'USA',
    airport: 'TEB — Teterboro Airport',
    stage: 'Final',
    stageTone: 'final',
    stageOrder: 1,
    highlightRow: true,
  },
  {
    rowOrder: 2,
    hostCity: 'Los Angeles',
    country: 'USA',
    airport: 'VNY — Van Nuys Airport',
    stage: 'Semifinal',
    stageTone: 'semifinal',
    stageOrder: 2,
    highlightRow: false,
  },
  {
    rowOrder: 3,
    hostCity: 'Dallas / Fort Worth',
    country: 'USA',
    airport: 'ADS — Addison Airport',
    stage: 'Semifinal',
    stageTone: 'semifinal',
    stageOrder: 2,
    highlightRow: false,
  },
  {
    rowOrder: 4,
    hostCity: 'Atlanta',
    country: 'USA',
    airport: 'PDK — DeKalb–Peachtree Airport',
    stage: 'Semifinal',
    stageTone: 'semifinal',
    stageOrder: 2,
    highlightRow: false,
  },
  {
    rowOrder: 5,
    hostCity: 'Miami',
    country: 'USA',
    airport: 'OPF — Opa-locka Executive Airport',
    stage: 'Quarterfinal',
    stageTone: 'quarterfinal',
    stageOrder: 3,
    highlightRow: false,
  },
  {
    rowOrder: 6,
    hostCity: 'San Francisco Bay Area',
    country: 'USA',
    airport: 'SQL — San Carlos Airport',
    stage: 'Group Stage',
    stageTone: 'group',
    stageOrder: 4,
    highlightRow: false,
  },
  {
    rowOrder: 7,
    hostCity: 'Seattle',
    country: 'USA',
    airport: 'BFI — Boeing Field',
    stage: 'Quarterfinal',
    stageTone: 'quarterfinal',
    stageOrder: 3,
    highlightRow: false,
  },
  {
    rowOrder: 8,
    hostCity: 'Boston',
    country: 'USA',
    airport: 'BED — Hanscom Field',
    stage: 'Quarterfinal',
    stageTone: 'quarterfinal',
    stageOrder: 3,
    highlightRow: false,
  },
  {
    rowOrder: 9,
    hostCity: 'Philadelphia',
    country: 'USA',
    airport: 'PNE — Northeast Philadelphia Airport',
    stage: 'Group Stage',
    stageTone: 'group',
    stageOrder: 4,
    highlightRow: false,
  },
  {
    rowOrder: 10,
    hostCity: 'Kansas City',
    country: 'USA',
    airport: 'JCI — New Century Aircenter',
    stage: 'Group Stage',
    stageTone: 'group',
    stageOrder: 4,
    highlightRow: false,
  },
  {
    rowOrder: 11,
    hostCity: 'Houston',
    country: 'USA',
    airport: 'HOU — William P. Hobby Airport',
    stage: 'Group Stage',
    stageTone: 'group',
    stageOrder: 4,
    highlightRow: false,
  },
  {
    rowOrder: 12,
    hostCity: 'Toronto',
    country: 'Canada',
    airport: 'YTZ — Billy Bishop Toronto City Airport',
    stage: 'Group Stage',
    stageTone: 'group',
    stageOrder: 4,
    highlightRow: false,
  },
  {
    rowOrder: 13,
    hostCity: 'Vancouver',
    country: 'Canada',
    airport: 'YVR — Vancouver International',
    stage: 'Group Stage',
    stageTone: 'group',
    stageOrder: 4,
    highlightRow: false,
  },
  {
    rowOrder: 14,
    hostCity: 'Mexico City',
    country: 'Mexico',
    airport: 'MMTO — Toluca International Airport',
    stage: 'Group Stage',
    stageTone: 'group',
    stageOrder: 4,
    highlightRow: false,
  },
  {
    rowOrder: 15,
    hostCity: 'Guadalajara',
    country: 'Mexico',
    airport: 'GDL — Miguel Hidalgo International',
    stage: 'Group Stage',
    stageTone: 'group',
    stageOrder: 4,
    highlightRow: false,
  },
  {
    rowOrder: 16,
    hostCity: 'Monterrey',
    country: 'Mexico',
    airport: 'MTY — Monterrey International',
    stage: 'Group Stage',
    stageTone: 'group',
    stageOrder: 4,
    highlightRow: false,
  },
];

export const BEST_AIRPORTS_WC2026_HEADER = [
  'Airport selection is the most underestimated planning variable. The travelers who face problems during FIFA World Cup 2026 will not be the ones who chose the wrong aircraft. They will be the ones who chose the wrong airport.',
];

export const BEST_AIRPORTS_WC2026_ROWS = [
  {
    left: {
      title: 'TEB — Teterboro Airport, New Jersey',
      desc: "New York metro's premier private jet airport and the gateway to MetLife Stadium for the World Cup Final. Teterboro enforces a strict 100,000-pound maximum takeoff weight limit. Ultra-long-range aircraft including the Bombardier Global 7500 and Gulfstream G650ER cannot operate there when fully fueled. Plan for Westchester County Airport (HPN) or Morristown Municipal (MMU) as alternates. MetLife Stadium approximately 18 miles. Teterboro FBO slots for Final week will be gone months in advance.",
    },
    right: {
      title: 'VNY — Van Nuys Airport, California',
      desc: "Los Angeles's largest dedicated business aviation airport and the preferred private jet gateway for Semifinal matches at SoFi Stadium. More FBO options and faster handling than LAX ramps. SoFi Stadium approximately 12 miles.",
    },
  },
  {
    left: {
      title: 'ADS — Addison Airport, Texas',
      desc: "North Dallas's primary executive airport with multiple high-capacity FBOs. The preferred private jet charter gateway for Semifinal matches at AT&T Stadium. AT&T Stadium approximately 20 miles.",
    },
    right: {
      title: 'OPF — Opa-locka Executive Airport, Florida',
      desc: "Miami's preferred private aviation facility for international arrivals with efficient customs clearance. The right choice for Quarterfinal travel arriving from Mexico or South America. Hard Rock Stadium approximately 10 miles.",
    },
  },
  {
    left: {
      title: 'PDK — DeKalb–Peachtree Airport, Georgia',
      desc: "Avoids Hartsfield-Jackson entirely. Keeps private jet travelers clear of the world's busiest commercial airport on World Cup match days. Mercedes-Benz Stadium approximately 14 miles.",
    },
    right: null,
  },
];

export const BEST_AIRPORTS_WC2026_GATEWAYS = {
  canada: {
    title: 'Canada Gateways',
    icon: 'leaf',
    bullets: [
      'YTZ — Billy Bishop Toronto City Airport: downtown access, 10-minute transfer to BMO Field.',
      'YVR — Vancouver International: dedicated private aviation facilities, 20-minute transfer to BC Place.',
    ],
  },
  mexico: {
    title: 'Mexico Gateways',
    icon: 'globe',
    bullets: [
      'MMTO — Toluca International: preferred alternative to congested AICM and AIFA for Mexico City. Approximately 45 miles to Estadio Azteca via highway.',
      'GDL — Miguel Hidalgo International, Guadalajara: strong private handling, 14 miles to Estadio Akron.',
      'MTY — Monterrey International: modern FBO facilities, 12 miles to Estadio BBVA.',
    ],
  },
};

export const BEST_AIRPORTS_WC2026_FBO = {
  icon: 'star',
  title: 'FBO Capacity — What Most Travelers Overlook',
  desc: 'FBO ramp space at peak airports is finite. During knockout rounds, parking at Teterboro, Van Nuys, and Addison will fill weeks before match day. Aircraft that cannot park overnight must reposition, adding a full ferry leg cost to your invoice. Book FBO slots at the same time you book your aircraft. FBOs at high-demand airports apply special event surcharges during major tournaments. Budget 20–40% above standard FBO rates for landing fees, handling, and parking during World Cup 2026 peak windows. These fees are not optional and are not always disclosed until invoicing unless your operator surfaces them upfront.',
};

/** Shown below interactive pricing tiers; copy from FIFA World Cup 2026 landing page brief */
export const WC_PRICING_TOURNAMENT_ALERT_BODY =
  'During knockout rounds through the Final, expect 30–60% surcharges above baseline due to aircraft scarcity, FBO event fees, and repositioning costs. Booking your private jet charter for World Cup 2026 early is the single most effective cost control strategy.';

export const PRICING_TIERS = [
  {
    id: 'light-regional',
    headline: 'Light Jet — Regional Hops',
    priceRange: '$8K–$20K',
    subtitle: '4–7 passengers · one-way',
    description:
      'Best for same-region sequences such as Dallas to Houston or Miami to Atlanta. Citation CJ3, Phenom 300 class. Up to approximately 2,000nm range.',
    image: '/imgs/svg/charterQuote/Light Jets.svg',
  },
  {
    id: 'midsize-cross',
    headline: 'Midsize Jet — Cross-Country (Most Popular)',
    priceRange: '$20K–$45K',
    subtitle: '6–9 passengers · one-way',
    description:
      'LA to New York, Dallas to Boston, and similar nonstop coast-to-coast routes. The best category for multi-city FIFA 2026 itineraries. Hawker 900, Citation XLS class.',
    image: '/imgs/svg/charterQuote/Midsize Jets.svg',
  },
  {
    id: 'super-heavy',
    headline: 'Super Midsize / Heavy Jet — Group and International',
    priceRange: '$45K–$90K',
    subtitle: '10–16 passengers · one-way',
    description:
      'Corporate jet charter World Cup 2026. US to Mexico and US to Canada segments. Stand-up cabin, full amenities. Gulfstream G450, Challenger 604 class.',
    image: '/imgs/svg/charterQuote/Heavy Jets.svg',
  },
  {
    id: 'vip-airliner',
    headline: 'VIP Airliner — Large Groups',
    priceRange: '$90K+',
    subtitle: '20–100+ passengers · per flight',
    description:
      'Group charter FIFA 2026 specialist. Built for corporate hospitality programs, sponsor delegations, and large fan groups. BBJ, ACJ, or narrow-body class. Multi-aircraft programs available.',
    image: '/imgs/svg/charterQuote/Large Jets.svg',
  },
];

/** Featured first; next four fill 2×2 per design */
export const FBO_SPOTLIGHTS = [
  {
    code: 'TEB',
    name: 'Teterboro Airport',
    detail: 'NYC metro private gateway — confirm weight limits and parking early during Cup weeks.',
    image: '/imgs/webp/affiliate/private-jet.webp',
    featured: true,
  },
  {
    code: 'VNY',
    name: 'Van Nuys Airport',
    detail: 'Preferred Los Angeles executive airport for SoFi Stadium runs.',
    image: '/imgs/webp/charterQuote/luxury.webp',
    featured: false,
  },
  {
    code: 'SQL',
    name: 'San Carlos Airport',
    detail: 'Bay Area business aviation alternative with Silicon Valley access.',
    image: '/imgs/webp/charterQuote/aircraft-img.webp',
    featured: false,
  },
  {
    code: 'ADS',
    name: 'Addison Airport',
    detail: 'Dallas–Fort Worth private option for North Texas match days.',
    image: '/imgs/webp/jetCard/charter.webp',
    featured: false,
  },
  {
    code: 'BFI',
    name: 'Boeing Field',
    detail: 'Seattle executive access with stadium and downtown connectivity.',
    image: '/imgs/webp/charterQuote/aircraft-options.webp',
    featured: false,
  },
];

export const REGULATION_ITEMS = [
  {
    title: 'Temporary Flight Restrictions and slot systems',
    body: 'Major events can drive TFRs and coordinated arrival/departure slots. Your crew will plan routings and timing against active NOTAMs and stadium-area restrictions.',
  },
  {
    title: 'TSA and security considerations',
    body: 'Private charter uses different access paths than airline terminals, but security and screening requirements still apply depending on route and operator program.',
  },
  {
    title: 'International Customs and Immigration',
    body: 'US, Canada, and Mexico segments require advance passenger manifests, customs coordination, and sometimes pre-clearance or APIS filings.',
  },
  {
    title: 'CBP and health screening protocols',
    body: 'Cross-border arrivals must meet CBP (and applicable health) processes. Your broker coordinates timing with FBO and customs to avoid ground delays.',
  },
  {
    title: 'Ground Logistics',
    body: 'Crew duty, handling, and tarmac transport should be planned together—especially when parking, tow, or overnight options are constrained during peak demand.',
  },
];

export const WC_REG_SPLASH_HEADER = [
  'The tri-country format introduces regulatory complexity that rarely appears at single-nation events. Operators must coordinate across FAA, Transport Canada, and AFAC simultaneously.',
];

export const GROUP_CHARTER_SPLASH_TITLE = 'Group Charter Flights for FIFA World Cup 2026';

export const GROUP_CHARTER_SPLASH_INTRO =
  'FIFA World Cup 2026 will drive one of the largest surges in corporate group charter demand the private aviation industry has seen. Group charter flights for FIFA 2026 are priced by aircraft, not per seat.';

export const GROUP_CHARTER_SPLASH_ITEMS = [
  {
    title: 'Priced by Aircraft, Not Per Seat',
    body: 'Per-passenger economics improve significantly when group size is matched correctly to aircraft category. A midsize jet carrying 8 passengers typically costs less per seat than 8 first-class commercial tickets across the same route, with no connection risk and a private terminal experience at both ends.',
  },
  {
    title: 'More Passengers, More Moving Parts',
    body: 'Group charter for World Cup 2026 requires coordinating match schedules against aircraft availability, ground transport at both ends, FBO throughput, customs processing for cross-border movements, and hotel arrival timing. Plan with an operator who specializes in event logistics.',
  },
  {
    title: 'When One Aircraft Is Not Enough',
    body: "For hospitality programs moving multiple groups between different host cities simultaneously, multi-aircraft programs let each group operate on its own optimized schedule. Consolidating everyone onto one aircraft that serves nobody's timing perfectly is a false economy.",
  },
  {
    title: 'Group Charter Needs More Lead Time',
    body: 'Sponsors and executive hospitality programs should begin coordinating group charter for FIFA World Cup 2026 now. FBO parking constraints, aircraft scarcity during knockout rounds, and cross-border customs sequencing all require significantly more advance planning than standard individual bookings.',
  },
];

export const WC_REG_SPLASH_ITEMS = [
  {
    title: 'Temporary Flight Restrictions Near Stadiums',
    body: 'The FAA issues TFRs around major sporting events. TFR zones near Final and Semifinal venues will affect departure timing, arrival windows, and routing for all private jet charter flights in the vicinity. Travelers flying into MetLife Stadium for the World Cup Final should expect some of the tightest managed airspace in the New York metro during tournament week. Experienced operators monitor NOTAMs continuously and build TFR windows into your routing plan before departure.',
  },
  {
    title: 'US, Canada, and Mexico Customs',
    body: 'Every cross-border private jet charter during World Cup 2026 requires advance APIS manifest submission, customs sequencing, and in some cases pre-clearance. For travelers flying between host cities in different countries such as Dallas to Monterrey or Seattle to Vancouver, these procedures must be built into your routing plan from the start.',
  },
  {
    title: 'Mexico and Canada Permits',
    body: 'International charter operations into Mexico and Canada require specific overflight and landing permits filed in advance. Last-minute permit issues are among the most common causes of operational delays during international sporting events. Experienced operators file permits concurrently with routing, not the morning of departure.',
  },
  {
    title: 'Airport Slots and Congestion',
    body: 'High-density airports near Final and Semifinal venues may impose arrival and departure slot windows during peak match periods. Missing a slot creates cascade delays across your entire multi-city itinerary. Every leg of a World Cup 2026 charter routing must account for slot timing, not just the destination airport but every upstream departure airport feeding into congested airspace.',
  },
  {
    title: 'Crew Duty Time',
    body: 'FAA Part 135 regulations govern crew flight time and duty limits. During high-demand World Cup weeks, crew availability will be compressed across the entire US charter market. Multi-leg World Cup 2026 itineraries should be booked through operators with confirmed crew resources allocated in advance, not just aircraft available on the ramp.',
  },
];

export const BOOKING_PHASES = [
  {
    title: 'Early Planning',
    desc: 'Lock aircraft categories, alternates, and rough match-cities before fleet and crew calendars tighten.',
    range: 'July 15–30, 2024',
  },
  {
    title: 'Slot Reservation',
    desc: 'Hold preferred airports/FBOs and confirm cross-border paperwork as fixtures firm up.',
    range: 'Jan 15–30, 2025',
  },
  {
    title: 'Finalize Itinerary',
    desc: 'Confirm legs, pax count, catering, and ground transport as tickets and hospitality schedules land.',
    range: 'Oct 1–15, 2025',
  },
  {
    title: 'Last Minute Bookings',
    desc: 'Possible in limited cases—expect premium pricing, tighter duty limits, and fewer airport choices.',
    range: 'Jun 2026',
  },
];

export const WC_WHEN_BOOK_INTRO = [
  'Private jet charter for FIFA World Cup 2026 is not a last-minute purchase. The aircraft market is finite. Supply and pricing shift quickly as the tournament approaches.',
];

export const WC_WHEN_BOOK_ACCORDION = [
  {
    question: 'Now Through 3 Months Out — Ideal Booking Window',
    answer:
      'Maximum aircraft selection, preferred FBO access, lowest repositioning exposure, and best pricing. Lock in multi-leg and group itineraries now. Knockout round dates can be held as conditional options while group stage travel is confirmed.',
  },
  {
    question: '3–6 Weeks Before Match Date — Acceptable With Trade-offs',
    answer:
      'Aircraft availability narrows, particularly heavy jets on long-range routes. Pricing premiums emerge on the highest-demand routes. FBO parking near Final and Semifinal venues starts filling.',
  },
  {
    question: 'Knockout Round Week-Of — High Risk, Premium Pricing',
    answer:
      'Supply is structurally constrained. Private jet charter prices during World Cup 2026 knockout rounds often run 40–80% above standard rates. Empty legs carry no schedule certainty and cannot be relied upon for fixed match-day travel.',
  },
  {
    question: 'Final Week, July 15–19, 2026 — Extremely Limited, Book Now',
    answer:
      'The World Cup Final at MetLife Stadium on July 19 will push Teterboro and surrounding airports to or beyond ramp capacity. Travelers without advance bookings should expect severely limited options, premium pricing, and potential rerouting to HPN or MMU.',
  },
];

export const WC_PLANNING_BANNER = {
  title: 'Planning World Cup Travel?',
  lead: 'Start with a match date and passenger count. Airacer sizes the right aircraft, airport strategy, and routing options for your schedule.',
  imageAlt:
    'Private jet charter at an FBO, planning FIFA World Cup 2026 itineraries across North America',
};

export const WC_FAQ_SPLIT_PANEL_TITLE = 'FAQ — Private Jet Charter for World Cup 2026';

export const WC_FAQ_SPLIT_BLOCKS = [
  {
    imgSrc: '/imgs/webp/jetCard/water.webp',
    imgAlt:
      'Private jet on the ramp at an FBO during peak demand for FIFA World Cup 2026 charter travel',
    caption:
      'Private jet on the ramp at an FBO during peak demand for FIFA World Cup 2026 charter travel',
    faq: [
      {
        question: 'How much does a private jet cost for FIFA World Cup 2026?',
        answer:
          'Baseline one-way costs range from $8,000 for regional light jet hops to $90,000+ for heavy jet international segments. Knockout round surcharges of 30–60% above baseline are expected. Booking early is the most effective way to control private jet charter costs for World Cup 2026.',
      },
      {
        question: 'Which private jet airport is best for the World Cup Final at MetLife Stadium?',
        answer:
          'Teterboro Airport (TEB) is the premier business aviation gateway to MetLife Stadium at approximately 18 miles. Note the 100,000-pound MTOW restriction. Ultra-long-range jets including the Global 7500 and G650ER should plan for Westchester County Airport (HPN) or Morristown Municipal (MMU) as alternates.',
      },
      {
        question: 'When should I book a private jet for World Cup 2026?',
        answer:
          'Book as early as possible, ideally 3 to 6 months in advance. Aircraft supply is finite and demand peaks sharply during knockout rounds. For Final week at Teterboro, FBO slots should be secured now.',
      },
      {
        question: 'Can I fly private between the US, Canada, and Mexico during the World Cup?',
        answer:
          'Yes. International private jet charter between all three host nations is fully supported. APIS manifest submission, customs coordination, and overflight and landing permits are handled by your operator as standard process when booked in advance.',
      },
      {
        question: 'Will there be TFRs near World Cup stadiums?',
        answer:
          'Yes. The FAA issues Temporary Flight Restrictions around major sporting events. TFR zones near Final and Semifinal venues will affect arrival sequencing, departure windows, and routing. Experienced operators build TFR compliance into your routing plan and monitor NOTAMs continuously throughout the tournament.',
      },
      {
        question: 'Can large private jets land at Teterboro Airport?',
        answer:
          'Teterboro enforces a strict 100,000-pound maximum takeoff weight limit. The Bombardier Global 7500 and Gulfstream G650ER exceed this when fully fueled. Plan for Westchester County Airport (HPN) or Morristown Municipal (MMU) as alternates for those aircraft types during World Cup Final week.',
      },
      {
        question: 'Are empty-leg flights good options for World Cup travel?',
        answer:
          'Empty legs are unpredictable during the tournament. Timing and routing of available legs will rarely align with fixed match schedules. Travelers attending multiple matches should prioritize operational certainty over discounted positioning opportunities.',
      },
      {
        question: 'Can Airacer arrange group charter for corporate or sponsor travel?',
        answer:
          'Yes. Group charter flights for FIFA 2026 are priced by aircraft, not per seat. Midsize jets handle groups of 6 to 9. Corporate hospitality groups typically require heavy jets or VIP airliners. Multi-aircraft programs are available for large sponsor delegations attending matches across multiple host cities simultaneously.',
      },
    ],
  },
];
